import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";

export interface KpiCustomerItem {
    label: string
    customerNumber: string
    id: string
}

class KpiCustomerStore {
    get items(): KpiCustomerItem[] {
        return this._items;
    }

    set items(value: KpiCustomerItem[]) {
        this._items = value;
    }

    private _items: KpiCustomerItem[] = []

    constructor() {
        makeAutoObservable(this)
    }

    async search(query: string): Promise<KpiCustomerItem[]> {
        const response = await catchApi(async () => api.kpi.api.findCustomers({query: query}))
        return (response?.data || []).map(item => ({
            label: `${item.name}${item.displayName ? ` [${item.displayName}]` : ''} (${item.customerNumber})`,
            customerNumber: `${item.customerNumber}`,
            id: `${item.customerId}`
        }))
    }

    async init() {
        if (!this.items.length) {
            await this.load()
        }
    }

    async load() {
        // no catch api since we are using it on the dashboard
        const response = await api.kpi.api.findCustomers()
        if (response && response.data) {
            this.items = (response.data || []).map(item => ({
                label: `${item.name}${item.displayName ? ` [${item.displayName}]` : ''} (${item.customerNumber})`,
                customerNumber: `${item.customerNumber}`,
                id: `${item.customerId}`
            }))
        }
    }

    getCustomerById(customerId: string | undefined): KpiCustomerItem | undefined {

        if (customerId) {
            return this.items.find(e => e.id === customerId)
        }
    }
}

const kpiCustomerStore = new KpiCustomerStore()

export {
    kpiCustomerStore
}
